var BaseAuthenticationClient = /** @class */ (function () {
    function BaseAuthenticationClient(options) {
        this.options = options;
    }
    Object.defineProperty(BaseAuthenticationClient.prototype, "appHost", {
        get: function () {
            var _a = this.options, appHost = _a.appHost, domain = _a.domain, host = _a.host;
            // The latest version, passed in appHost
            if (appHost) {
                return appHost.replace(/\/$/, '');
            }
            // Compatible with the domain passed in the protocol authentication API
            else if (domain) {
                var hostUrl = new URL(this.options.host);
                return hostUrl.protocol + "//" + this.options.domain;
            }
            // Finally, use the server unified domain name host
            else {
                return host;
            }
        },
        enumerable: false,
        configurable: true
    });
    return BaseAuthenticationClient;
}());
export { BaseAuthenticationClient };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQmFzZUF1dGhlbnRpY2F0aW9uQ2xpZW50LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2xpYi9hdXRoZW50aWNhdGlvbi9CYXNlQXV0aGVudGljYXRpb25DbGllbnQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRUE7SUFxQkUsa0NBQVksT0FBb0M7UUFDOUMsSUFBSSxDQUFDLE9BQU8sR0FBRyxPQUFPLENBQUM7SUFDekIsQ0FBQztJQXBCRCxzQkFBSSw2Q0FBTzthQUFYO1lBQ1EsSUFBQSxLQUE0QixJQUFJLENBQUMsT0FBTyxFQUF0QyxPQUFPLGFBQUEsRUFBRSxNQUFNLFlBQUEsRUFBRSxJQUFJLFVBQWlCLENBQUM7WUFDL0Msd0NBQXdDO1lBQ3hDLElBQUksT0FBTyxFQUFFO2dCQUNYLE9BQU8sT0FBTyxDQUFDLE9BQU8sQ0FBQyxLQUFLLEVBQUUsRUFBRSxDQUFDLENBQUM7YUFDbkM7WUFDRCx1RUFBdUU7aUJBQ2xFLElBQUksTUFBTSxFQUFFO2dCQUNmLElBQUksT0FBTyxHQUFHLElBQUksR0FBRyxDQUFDLElBQUksQ0FBQyxPQUFPLENBQUMsSUFBSSxDQUFDLENBQUM7Z0JBQ3pDLE9BQVUsT0FBTyxDQUFDLFFBQVEsVUFBSyxJQUFJLENBQUMsT0FBTyxDQUFDLE1BQVEsQ0FBQzthQUN0RDtZQUVELG1EQUFtRDtpQkFDOUM7Z0JBQ0gsT0FBTyxJQUFJLENBQUM7YUFDYjtRQUNILENBQUM7OztPQUFBO0lBS0gsK0JBQUM7QUFBRCxDQUFDLEFBeEJELElBd0JDIn0=